module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/roma.214f51c4d94cc02dc52fe5e264cd3084.jpg";